import { useTranslation } from 'next-i18next'
// Dependencies.
import styled, { css } from 'styled-components'

import { H3 } from '../H3'
import { Modal } from '../Modal'
import { CTA } from '../CTA'
import { forScreensGreaterThanMobileWidth } from '../../utils'
import { Hyperlink } from '../Hyperlink'
import { EventHookInterface } from '../../types'
import { ModalContentWrapper } from '../ModalContentWrapper'
import { EventModalContentWrapper } from '../Event/Hero/EventModalContentWrapper'
import { useAnalyticsEvent } from '../../hooks/analyticsEvent'

// Div.
const Div = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 30px;

  .header {
    margin-bottom: 30px;
    text-align: left;
  }

  .logInCTA {
    margin-bottom: 15px;
  }

  .signUpCTA {
  }

  .hyperlink,
  ${CTA} {
    width: 100%;
  }
`

// Props.
interface Props {
  close: () => void
  eventHook: EventHookInterface
}

// Sign In To Join.
export const SignInToJoinModal: React.FC<Props> = ({ close, eventHook }) => {
  const { t } = useTranslation('common')

  const eventId = eventHook.value.id

  const analyticsEvent = useAnalyticsEvent()

  // ..
  return (
    <Modal close={close}>
      {/* Event Modal Content Wrapper. */}
      <EventModalContentWrapper eventHook={eventHook}>
        <Div>
          {/* Header. */}
          <H3 className="header">
            {t(
              `SignInToJoinModal-1995937883`,
              `To book your seat at this event, login or sign up to Klyk.`,
            )}
          </H3>

          {/* Log In CTA. */}
          <Hyperlink
            className="logInCTA"
            href={`/login?redirect=/events/${eventId}`}>
            <CTA className="purple">{t(`Log in`, `Log in`)}</CTA>
          </Hyperlink>

          {/* Sign Up CTA. */}
          <Hyperlink
            className="signUpCTA"
            href={`/signup?redirect=/events/${eventId}`}
            onClick={() => {
              analyticsEvent.signupLinkClicked('attend-event')
            }}>
            <CTA className="signUpCTA">{t(`Sign up`, `Sign up`)}</CTA>
          </Hyperlink>
        </Div>
      </EventModalContentWrapper>
    </Modal>
  )
}
